import React from "react";
import { Alert } from "react-bootstrap";

const NoDashboardAccess = () => {
  return (
    <div className="container py-5" style={{ maxWidth: 640 }}>
      <Alert variant="info">Welcome to WorldShine System!</Alert>
    </div>
  );
};

export default NoDashboardAccess;
